export default "__VITE_ASSET__GtCYqE0U__"